export default __webpack_public_path__ + "static/media/3070.b0dcf614.jpg";